// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close:hover {
  color: black;
  background-color: transparent;
}

.wrapper-buttons {
  display: flex;
  justify-content: space-around;
  text-align: center;
}
.wrapper-buttons .button-redirect {
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 200px;
  height: 200px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  padding-top: 10px;
}
.wrapper-buttons .button-redirect:hover {
  opacity: 0.7;
}
.wrapper-buttons .button-redirect .content--sample {
  margin: auto;
}
.wrapper-buttons .button-redirect img {
  width: 100%;
  height: 100%;
}
.wrapper-buttons .button-redirect .footer-text {
  bottom: 0;
  background-color: #386fa4;
  color: white;
  position: absolute;
  width: 100%;
  padding: 8px;
}
.wrapper-buttons .button-redirect.button-redirect--simple .content--sample {
  width: 100px;
}
.wrapper-buttons .button-redirect.button-redirect--details .content--sample {
  width: 200px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
